import React, { Component } from 'react';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {TextField} from 'redux-form-material-ui';
import Grid from 'material-ui/Grid';
import {Validator} from '../../core/Validator';
import {connect} from 'react-redux';

const validate = values => Validator.build(values, {
    'title': [Validator.required],
    'content': [Validator.required],
    'resume': [Validator.required, Validator.max(150)]
});

class GuideForm extends Component{

    render(){
        return (
            <div style={{padding: '16px 8px'}}>
                <form onSubmit={this.props.handleSubmit}>
                    <Grid container>
                        <Grid item md={12}>
                            <Field
                                name="title"
                                fullWidth={true}
                                component={TextField}
                                label="Titre"
                            />
                        </Grid>
                        <Grid item md={12}>
                            <Field
                                name="resume"
                                fullWidth={true}
                                component={TextField}
                                label="Résumé"
                                multiline
                                rows={2}
                                helperText={`${this.props.resume ? this.props.resume.length : 0}/150`}
                            />
                        </Grid>
                        <Grid item md={12}>
                            <Field
                                name="content"
                                multiline
                                fullWidth={true}
                                component={TextField}
                                label="Contenu"
                                rows={5}
                            />
                        </Grid>
                    </Grid>
                </form>
            </div>
        )
    }
}

const selector = formValueSelector('guideForm');

const state2Props = state => ({
    resume: selector(state, 'resume')
});

export default reduxForm({
    form: 'guideForm',
    validate
})(connect(state2Props)(GuideForm));


// WEBPACK FOOTER //
// ./src/pages/guides/GuideForm.js